module.exports = __webpack_public_path__ + "static/media/alarm-clock.873f32d2.svg";